import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui';
import {ConversationParticipant} from '@stripe-internal/conversations-client';
import {useMemo} from 'react';
import {MetaRow} from './MetaRow';
import {
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
} from '../../FeatureFlagsProvider';
import {useTheme} from '../../ThemeProvider';

const messages = defineMessages({
  participantJoined: {
    id: 'conversations_ui.chat.row.participantJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name} has joined.',
  },
  supportAgentJoined: {
    id: 'conversations_ui.chat.row.supportAgentJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name}, a Stripe support agent, has joined the chat.',
  },
  salesAgentJoined: {
    id: 'conversations_ui.chat.row.salesAgentJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: 'Connected to {name}, a Stripe sales representative.',
  },
});

export const JoinRow = ({
  role,
  name,
}: {
  role?: ConversationParticipant['role'];
  name: string;
}) => {
  const theme = useTheme();
  const useNewDesigns = useNewUniversalHelpDesign();
  const useDotComDesign = useUniversalHelpDotComDesign();

  const message = useMemo(() => {
    if (role === 'agent' && !theme.messageKey) {
      if (useNewDesigns) return messages.supportAgentJoined;
      if (useDotComDesign) return messages.salesAgentJoined;
    }

    return messages.participantJoined;
  }, [useNewDesigns, useDotComDesign, role, theme]);

  return (
    <view.div data-testid="join-row">
      <MetaRow>
        <FormattedMessage {...message} values={{name}} />
      </MetaRow>
    </view.div>
  );
};

export default JoinRow;
